// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__SBSuV","error":"Input_error__nLmJQ"};